/**
 * Mock data for Insights reports (frontend-only, no backend).
 */
export const MOCK_INSIGHTS_SERIES = {
  series: [
    { date: "2024-09-01", value: 120 },
    { date: "2024-09-02", value: 150 },
    { date: "2024-09-03", value: 142 },
    { date: "2024-09-04", value: 178 },
    { date: "2024-09-05", value: 165 },
    { date: "2024-09-06", value: 190 },
    { date: "2024-09-07", value: 210 },
    { date: "2024-09-08", value: 195 },
    { date: "2024-09-09", value: 220 },
    { date: "2024-09-10", value: 245 },
    { date: "2024-09-11", value: 230 },
    { date: "2024-09-12", value: 260 },
    { date: "2024-09-13", value: 248 },
    { date: "2024-09-14", value: 272 },
    { date: "2024-09-15", value: 255 },
    { date: "2024-09-16", value: 280 },
    { date: "2024-09-17", value: 290 },
    { date: "2024-09-18", value: 275 },
    { date: "2024-09-19", value: 302 },
    { date: "2024-09-20", value: 315 },
    { date: "2024-09-21", value: 298 },
    { date: "2024-09-22", value: 320 },
    { date: "2024-09-23", value: 335 },
    { date: "2024-09-24", value: 318 },
    { date: "2024-09-25", value: 342 },
    { date: "2024-09-26", value: 355 },
    { date: "2024-09-27", value: 340 },
    { date: "2024-09-28", value: 368 },
    { date: "2024-09-29", value: 375 },
    { date: "2024-09-30", value: 362 },
  ],
  summary: {
    avg: 255,
    total: 7650,
    delta: "+12.5%",
    metric: "document_created",
  },
};

export const MOCK_EVENTS = [
  { id: "page_view", label: "page_view", group: "Events" },
  { id: "sign_up", label: "sign_up", group: "Events" },
  { id: "document_created", label: "document_created", group: "Events" },
  { id: "wallet_connected", label: "wallet_connected", group: "Events" },
  { id: "DAU", label: "DAU", group: "Formulas" },
  { id: "MAU", label: "MAU", group: "Formulas" },
  { id: "Stickiness", label: "Stickiness", group: "Formulas" },
];

export const MOCK_FUNNEL_STEPS = [
  { id: "s1", label: "sign_up", count: 1000, conversion: 100 },
  { id: "s2", label: "document_created", count: 650, conversion: 65 },
  { id: "s3", label: "payment_success", count: 320, conversion: 32 },
];
